import {makeStyles} from 'external/material'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    padding: 30,
    "& .definitions": {
      minWidth: 300,
      flexGrow: 1,
      padding: '9px 0'
    },
    "& .terms": {
      minWidth: 300,
      flexGrow: 1,
      paddingRight: '10px'
    },
    "& .term": {
      display: 'flex',
      margin: 'auto 0'
    },
    "& .index": {
      textTransform: 'lowercase',
      fontWeight: 'bold',
      marginRight: 10
    },
    "& .value": {
      ...verticalCentering
    },
    "& .select-definition": {
      marginRight: 10,
      height: 50
    },
    "& .definition": {
      display: "flex",
      margin: '8px 0 8px 16px',
      "&.selected": {
        opacity: 0.5
      }
    }
  },
}))

export {useStyles as default}
